import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import _ from 'lodash';

import { EMOJI_TYPES } from 'client/types';

import * as actions from '../actions';
import { PubnubState } from '..';

export const getReactionsMsgsBuilder = (builder: ActionReducerMapBuilder<PubnubState>) => {
  return builder
    .addCase(actions.getReactionsMessages.pending, (state) => {
      state.isBusy = true;
    })
    .addCase(actions.getReactionsMessages.fulfilled, (state, action) => {
      const newData: PubnubState['reactions']['messages'] | Record<string, never> = _.reduce(
        action.payload.channels,
        (acc, item, key) => {
          const targetKey = key.split('.').pop();
          if (targetKey) {
            _.set(acc, targetKey as EMOJI_TYPES, _.orderBy(item, 'timetoken', 'desc'));
          }

          return acc;
        },
        {},
      );

      const allMessages: PubnubState['reactions']['messages'] = state.reactions.messages;

      for (const key in allMessages) {
        if (newData[key]) {
          allMessages[key as EMOJI_TYPES] = [...allMessages[key as EMOJI_TYPES], ...newData[key]];
        } else {
          allMessages[key as EMOJI_TYPES] = [...allMessages[key as EMOJI_TYPES]];
        }
      }

      state.reactions.messages = allMessages;
      state.isBusy = false;
    })
    .addCase(actions.getReactionsMessages.rejected, (state) => {
      state.isBusy = true;
    });
};

export const getReactionsMsgsCountBuilder = (builder: ActionReducerMapBuilder<PubnubState>) => {
  return builder.addCase(actions.getReactionsMessagesCount.fulfilled, (state, action) => {
    const newData = _.reduce(
      action.payload,
      (acc, item, key) => {
        const targetKey = key.split('.').pop();

        if (targetKey) _.set(acc, targetKey as EMOJI_TYPES, item);

        return acc;
      },
      {},
    );

    state.reactions.counts = { ...state.reactions.counts, ...(newData as PubnubState['reactions']['counts']) };
    state.isBusy = false;
  });
};
